import { Notifier } from '@airbrake/browser';

import { getEnvironment, isDevelopment, isStaging } from './environment';

const isDev = isDevelopment();

function checkArraylikeObject(obj, values) {
  [].slice.call(obj).every((value, index) => value === values[index]);
}

function logger(notice) {
  if (isDev || isStaging()) {
    // eslint-disable-next-line
    console.warn('Airbrake notice', notice);
  }
}

const FILTERS = [
  notice => {
    const block = isDev;

    Object.assign(notice.context, {
      environment: getEnvironment(),
      os: navigator.platform
    });

    logger(notice);

    return block ? null : notice;
  },
  notice => {
    const block = notice.errors.some(error => /Blocked a frame with origin/.test(error.message));

    logger(notice);

    return block ? null : notice;
  },
  notice => {
    const { params } = notice;
    let block = false;

    if (params) {
      block = checkArraylikeObject(params, ['dispatchEvent', 'cross-origin']);
      logger(notice);
    }

    return block ? null : notice;
  },
  notice => {
    // add more strings as necessary
    const items = [
      '_AutofillCallbackHandler',
      "(reading 'style')",
      "Can't find variable: gmo"
    ];
    const block = notice.errors.some(error => {
      return items.some(item => error.message.indexOf(item) !== -1);
    });

    logger(notice);

    return block ? null : notice;
  }
];

const PROJECT_ID = 80953;
const PROJECT_KEY = '413697d851828380dc389bef0911549e';

const notifier = new Notifier({ projectId: PROJECT_ID, projectKey: PROJECT_KEY });

FILTERS.forEach(filter => {
  notifier.addFilter(filter);
});

export default notifier;



// WEBPACK FOOTER //
// ./shared/helpers/airbrake.js